// Centralized Menu Item Styles
// Centralized Menu Item Styles
export const menuItemStyles = {
  fontSize: "14px", // Adjust font size
  padding: "4px 8px", // Custom padding
  "& .MuiTypography-root": { fontSize: "14px" }, // Ensures ListItemText text size
};
